/*
 *  Featured Video
 *    Scripts for the video modal
 *
 *  Version:
 *    1.0.0 - 2022/02/17
 */

import { LightBoxElement } from '../../objects/light-box';

const SELECTOR_CONTAINER = '[data-popup-container]';
const SELECTOR_LIGHTBOX = '[data-popup-box]';
const SELECTOR_MODAL_BUTTON = '[data-popup-btn]';
const SELECTOR_CLOSE = '[data-popup-close]';
const SELECTOR_VIDEO = '[data-video]';

document
  .querySelectorAll<HTMLDivElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    const lightBox =
      container.querySelector<LightBoxElement>(SELECTOR_LIGHTBOX);
    const openLightbox = container.querySelector<HTMLElement>(
      SELECTOR_MODAL_BUTTON
    );
    const closeButton = container.querySelector<HTMLElement>(SELECTOR_CLOSE);
    const video = container.querySelector<HTMLVideoElement>(SELECTOR_VIDEO);

    if (!lightBox || !openLightbox || !closeButton || !video) return;

    openLightbox.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);

    function openModal() {
      if (!lightBox || !video) return;
      lightBox.visible = true;
      video.play();
    }

    function closeModal() {
      if (!lightBox || !video) return;
      video.pause();
      lightBox.visible = false;
    }
  });
